import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  popoverPaper: {
    borderRadius: 8,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    minWidth: 180,
    fontFamily: theme.typography.fontFamily
  },

  menuList: {
    listStyle: 'none',
    margin: 0,
    padding: '4px 0'
  },

  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    padding: '10px 16px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'inherit',
    color: theme.palette.primary.main,
    transition: 'background-color 0.2s',

    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },

  menuIcon: {
    fontSize: 20,
    color: theme.palette.primary.main
  }
}))
